import React from "react";
import classNames from "classnames";
import { Text } from "common/text";
import { IconClose } from "common/icon/close";
import { IconCheck } from "common/icon/check";

import "./../form.scss";

export function CardFormNumber({
  className,
  valid,
  pristine,
  value,
  onBlur,
  onInput,
}) {
  const showError = !pristine && !valid;
  const showValidity = !pristine && valid;

  const classes = {
    "card-form-field": true,
    "card-form-field--invalid": showError,
    "card-form-field--valid": showValidity,
  };

  return (
    <div className={classNames(classes, className)}>
      <label className="card-form-field__label">Card number</label>
      <IconCheck className="card-form-field__icon-valid icon--success" />
      <IconClose className="card-form-field__icon-invalid icon--danger" />
      <input
        className="card-form-field__input"
        type="text"
        placeholder="0000 0000 0000 0000"
        value={value || ""}
        onBlur={() => onBlur()}
        onChange={(event) => onInput(event.target.value)}
      />
      <Text className="card-form-field__error-message text--small">
        Please enter a valid credit card number
      </Text>
    </div>
  );
}
